<template>
  <div class="program-page">
    <div v-for="(item, index) in programList" :key="index" class="item-div">
      <p class="item-title" v-html="item.title"></p>

      <div class="second img-left">
        <img :src="imageSrc(item.num)" alt="">
        <div class="desc-div">
          <p class="desc">{{item.desc}}</p>
          <ul>
            <li>
              <div><p>활동 시기 :&nbsp;</p></div>
              <div><p>{{item.date}}</p></div>
            </li>
            <li>
              <div><p>활동 대상 :&nbsp;</p></div>
              <div><p>{{item.target}}</p></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsrYouthFootballClass',
  data() {
    return {
      programList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.programList = [
        {
          num: 2,
          title: '포스코 퓨처엠과 함께하는<br>푸른 꿈 축구교실',
          desc: '"푸른 꿈 축구교실"은 포스코퓨처엠이 전남드래곤즈 선수들과 함께 축구교실 운영을 통해 미래세대의 꿈을 키우고 지역 아동들의 건강한 성장을 돕는 프로그램입니다.',
          date: '2026년 3월 ~ 9월',
          target: '광양 지역아동센터 57명'
        },
      ];
    },

    imageSrc(num) {
      return require(`@/assets/img/club/program_0${num}.png`);
    },
  },
};
</script>

<style scoped>
.total-year-records {
  padding-right: 0;
}

.total-year-records table {
  min-width: auto;
}

@media (max-width: 959px) {
  .total-year-records table {
    min-width: 800px;
  }
}
</style>
